import React, { useEffect, useState } from "react";
import { getCourseBatch, API_BASE } from "../Services/Api";
import "./Mycourse.css";

export default function MyCourse() {
  const [enrolledCourses, setEnrolledCourses] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const fetchEnrolledCourses = async () => {
      try {
        const response = await getCourseBatch();
        console.log(`entrolled ${response.enrolled_courses}`)

        if (response?.status) {
          const { courses, enrolled_courses } = response;

          const matchedCourses = enrolled_courses.map((enrolled) => ({
  id: enrolled.main_course,
  course_name: enrolled.course_name,
  image: enrolled.image,
  course_price: enrolled.course_price,
  moodle_course_id: enrolled.moodle_course_id,
}));


          setEnrolledCourses(matchedCourses);
        }
      } catch (error) {
        console.error("Error fetching enrolled courses:", error);
        setEnrolledCourses([]);
      } finally {
        setLoading(false);
      }
    };

    fetchEnrolledCourses();
  }, []);

  const handleGetAccess = async (moodleCourseId) => {
    try {
      const res = await fetch(`${API_BASE}/connect-course`, {
        method: "POST",
        credentials: "include",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({ courseId: moodleCourseId }),
      });

      const html = await res.text();
      document.open();
      document.write(html);
      document.close();
    } catch (err) {
      console.error("Error connecting to course:", err);
    }
  };

  const SkeletonCard = () => (
    <div className="bg-white shadow-md rounded-xl overflow-hidden animate-pulse">
      <div className="relative w-full h-48 bg-gray-300"></div>
      <div className="p-4 flex flex-col items-center text-center">
        <div className="h-4 bg-gray-300 rounded w-3/4 mb-3"></div>
        <div className="h-8 bg-gray-300 rounded w-1/2"></div>
      </div>
    </div>
  );

  return (
    <>
      <title>My Courses</title>
   

        {/* Banner */}
        <div className="w-full bg-gray-50"  style={{ backgroundColor: "rgb(219 228 220 / 23%)" }}>
          <div className="container mx-auto flex flex-col md:flex-row gap-20 items-center py-10">
            <div className="w-full md:w-1/2">
            
              <img
                src="/images/mycourse.png"
                alt="Banner"
                className="w-full object-contain"
              />
            </div>

           <div className="w-full md:w-1/2 p-8 flex flex-col justify-center text-center md:text-left">
            <h1 className="text-3xl md:text-4xl font-bold mb-4 text-gray-900">
               My Courses
            </h1>
            <p className="text-gray-700 text-lg mb-6">
              Here you can find all your enrolled courses and continue your
              learning journey with ease. Track your progress, access study
              material, and achieve your goals step by step.
            </p>

            {/* ✅ Extra Content */}
            <ul className="text-gray-600 mb-6 space-y-2">
              <li className="flex items-center">
                <span className="text-green-600 mr-2">✔</span> Access enrolled
                courses anytime
              </li>
              <li className="flex items-center">
                <span className="text-green-600 mr-2">✔</span> Track progress &
                completion
              </li>
              <li className="flex items-center">
                <span className="text-green-600 mr-2">✔</span> Continue learning
                without limits
              </li>
            </ul>

            {/* ✅ Call-to-Action */}
            <div className="flex justify-center md:justify-start space-x-4">
              {/* <button className="px-6 py-3 bg-blue-600 text-white rounded-lg shadow-md hover:bg-blue-700 transition">
                Continue Learning
              </button> */}
              {/* <button className="px-6 py-3 bg-gray-200 text-gray-800 rounded-lg shadow-md hover:bg-gray-300 transition">
                Explore More Courses
              </button> */}
            </div>
          </div>
          </div>
        </div>

        {/* Courses Section */}
        <div className="container mx-auto p-6">
          <h2 className="text-3xl font-bold mb-10 text-center">My Courses</h2>

          {loading ? (
            <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-10">
              {Array.from({ length: 3 }).map((_, i) => (
                <SkeletonCard key={i} />
              ))}
            </div>
          ) : enrolledCourses.length > 0 ? (
            <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-10 justify-items-center">
              {enrolledCourses.map((course) => (
                <div key={course.id} className="hero second w-full max-w-sm">

                  {/* IMAGE */}
                  <img
                    src={
                      course.image
                        ? `https://edcbackend.lsc-india.org/${course.image}`
                        : "/default-course.jpg"
                    }
                    alt={course.course_name}
                    className="hero-profile-img"
                  />

                  {/* YELLOW SHAPE */}
                  <div className="hero-description-bk"></div>

                  {/* TITLE */}
                  <div className="hero-description">
                    <p>{course.course_name}</p>
                  </div>

                  {/* PRICE */}
                  <div className="hero-date">
                    <p>Rs.{course.course_price}</p>
                  </div>

                  {/* BUTTON */}
                  <div className="hero-btn">
                    <button
                      onClick={() =>
                        handleGetAccess(course.moodle_course_id)
                      }
                    >
                     Get Access
                    </button>
                  </div>
                </div>
              ))}
            </div>
          ) : (
            <p className="text-center py-6 text-gray-400">
              You have not enrolled in any courses yet.
            </p>
          )}
        </div>
   
    </>
  );
}
